export { default as CmsEditorialHero } from './CmsEditorialHero';
